import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/global.scss'

import App from './App.vue'
import router from './router'
import setupPermissionDirective from './directives/permission'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { size: 'default', zIndex: 3000 })

// 注册权限指令
setupPermissionDirective(app)

// 全局错误处理
app.config.errorHandler = (err: unknown, _instance, info) => {
  console.error('[Global Error Handler]', err, 'info:', info)
  // 可在此处接入错误上报服务(如 Sentry)
}

// 全局 Promise 未捕获异常处理
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise Rejection]', event.reason)
  event.preventDefault()
})

app.mount('#app')
